import { LoadingButton } from '@mui/lab';
import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)``;

export const Button = styled(LoadingButton)``;
